import { render } from "./ProductViewRank.vue?vue&type=template&id=57411818"
import script from "./ProductViewRank.vue?vue&type=script&lang=js"
export * from "./ProductViewRank.vue?vue&type=script&lang=js"

import exportComponent from "F:\\admin_om\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__